<template>
    <div class="col-md-12 px-0 py-0 mt-5">
        <form class="form-horizontal">
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Nombre</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="name"
                        class="form-control"
                        placeholder="Nombre"
                    />
                    <span v-if="allerrors.name" :class="['show-error']">{{
                        allerrors.name[0]
                    }}</span>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Resumen</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="summary"
                        class="form-control"
                        placeholder="Resumen"
                    />
                    <span v-if="allerrors.summary" :class="['show-error']">{{
                        allerrors.summary[0]
                    }}</span>
                </div>
            </div>

            <div class="form-group row">
                <label
                    class="col-md-3 form-control-label"
                    for="text-input"
                ></label>
                <div class="col-md-9">
                    <div id="fine-uploader-manual-trigger"></div>
                    <span v-if="allerrors.image" :class="['show-error']">{{
                        allerrors.image[0]
                    }}</span>
                    <a
                        v-if="image_path"
                        :href="image_path"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Ver imagen</a
                    >
                </div>
            </div>
            <div class="form-group row">
                <label
                    class="col-md-3 form-control-label"
                    for="text-input"
                ></label>
                <div class="col-md-9">
                    <div id="fine-uploader-manual-trigger-webp"></div>
                    <span v-if="allerrors.image_webp" :class="['show-error']">{{
                        allerrors.image_webp[0]
                    }}</span>
                    <a
                        v-if="image_webp_path"
                        :href="image_webp_path"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Ver imagen</a
                    >
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Alt image</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="text_image_alt"
                        class="form-control"
                        placeholder="Alt image"
                    />
                    <span
                        v-if="allerrors.text_image_alt"
                        :class="['show-error']"
                        >{{ allerrors.text_image_alt[0] }}</span
                    >
                </div>
            </div>

            <div class="form-group row">
                <label
                    class="col-md-3 form-control-label"
                    for="text-input"
                ></label>
                <div class="col-md-9">
                    <div id="fine-uploader-manual-trigger-icon"></div>
                    <span v-if="allerrors.image_icon" :class="['show-error']">{{
                        allerrors.image_icon[0]
                    }}</span>
                    <a
                        v-if="image_icon_path"
                        :href="image_icon_path"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Ver imagen</a
                    >
                </div>
            </div>
            <div class="form-group row">
                <label
                    class="col-md-3 form-control-label"
                    for="text-input"
                ></label>
                <div class="col-md-9">
                    <div id="fine-uploader-manual-trigger-icon-webp"></div>
                    <span
                        v-if="allerrors.image_icon_webp"
                        :class="['show-error']"
                        >{{ allerrors.image_icon_webp[0] }}</span
                    >
                    <a
                        v-if="image_icon_webp_path"
                        :href="image_icon_webp_path"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Ver imagen</a
                    >
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Alt image icon</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="text_image_icon_alt"
                        class="form-control"
                        placeholder="Alt image icon"
                    />
                    <span
                        v-if="allerrors.text_image_icon_alt"
                        :class="['show-error']"
                        >{{ allerrors.text_image_icon_alt[0] }}</span
                    >
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Enfoques</label
                >
                <div class="col-md-9">
                    <table class="table">
                        <thead>
                            <tr>
                                <td><strong>Enfoques</strong></td>
                                <td></td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, index) in approaches" :key="index">
                                <td>
                                    <input
                                        type="text"
                                        v-model="row.description"
                                        class="form-control"
                                    />
                                </td>
                                <td style="padding: 10px 0px; font-size: 20px">
                                    <a
                                        @click="removeElement(index)"
                                        style="cursor: pointer"
                                        ><em class="fa fa-trash-o"></em
                                    ></a>
                                </td>
                            </tr>
                            <span
                                v-if="allerrors.approaches"
                                :class="['text-danger']"
                                >{{ allerrors.approaches[0] }}</span
                            >
                        </tbody>
                    </table>

                    <div>
                        <button
                            type="button"
                            class="btn btn-primary"
                            @click="addRow"
                        >
                            Agregar enfoque
                        </button>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button
                    v-if="model_id == 0"
                    type="button"
                    @click="create()"
                    class="btn btn-primary"
                >
                    Agregar
                </button>
                <button
                    v-if="model_id > 0"
                    type="button"
                    @click="update()"
                    class="btn btn-primary"
                >
                    Actualizar
                </button>
            </div>
        </form>
        <template-uploader></template-uploader>
        <template-uploader
            template_id="qq-template-manual-trigger-webp"
            text_button="Imagen webp"
        ></template-uploader>
        <template-uploader
            template_id="qq-template-manual-trigger-icon"
            text_button="Imagen icon"
        ></template-uploader>
        <template-uploader
            template_id="qq-template-manual-trigger-icon-webp"
            text_button="Imagen icon webp"
        ></template-uploader>
    </div>
</template>
<script>
import qq from "fine-uploader";
import "fine-uploader/fine-uploader/fine-uploader-new.min.css";
export default {
    props: {
        model_id: Number,
    },
    data() {
        return {
            action: "",
            summary: null,
            name: null,
            image: null,
            image_webp: null,
            image_icon: null,
            image_icon_webp: null,
            text_image_alt: null,
            text_image_icon_alt: null,
            image_path: null,
            image_webp_path: null,
            image_icon_path: null,
            image_icon_webp_path: null,
            description: null,
            approaches: [],
            allerrors: {
                name: null,
                image: null,
                image_webp: null,
                image_icon: null,
                image_icon_webp: null,
                summary: null,
                text_image_alt: null,
                text_image_icon_alt: null,
                approaches: null,
            },
        };
    },
    methods: {
        getModel() {
            let me = this;
            axios
                .get(`/api/categories/show?category_id=${me.model_id}`)
                .then(function (response) {
                    me.name = response.data.model.name;
                    me.summary = response.data.model.summary;
                    me.image = response.data.model.image;
                    me.image_webp = response.data.model.image_webp;
                    me.text_image_alt = response.data.model.text_image_alt;
                    me.image_icon = response.data.model.image_icon;
                    me.image_icon_webp = response.data.model.image_icon_webp;
                    me.text_image_icon_alt =
                        response.data.model.text_image_icon_alt;
                    me.image_path = response.data.image_path;
                    me.image_webp_path = response.data.image_webp_path;
                    me.image_icon_path = response.data.image_icon_path;
                    me.image_icon_webp_path =
                        response.data.image_icon_webp_path;
                    me.approaches = response.data.approaches
                        ? response.data.approaches
                        : [];
                })
                .catch(function (error) {});
        },
        create() {
            let me = this;
            if (me.validForm()) {
                axios
                    .post(me.action, {
                        summary: me.summary,
                        name: me.name,
                        image: me.image,
                        image_webp: me.image_webp,
                        text_image_alt: me.text_image_alt,
                        image_icon: me.image_icon,
                        image_icon_webp: me.image_icon_webp,
                        text_image_icon_alt: me.text_image_icon_alt,
                        approaches: me.approaches,
                    })
                    .then(function (response) {
                        me.clearError();
                        me.showActionSuccess("Creacion exitosa!");
                        me.$emit("change");
                    })
                    .catch(function (error) {
                        if (error.response && error.response.data) {
                            me.allerrors = error.response.data.errors;
                        }
                    });
            }
        },
        update() {
            let me = this;
            if (me.validForm()) {
                axios
                    .put(me.action, {
                        summary: me.summary,
                        name: me.name,
                        image: me.image,
                        image_webp: me.image_webp,
                        text_image_alt: me.text_image_alt,
                        image_icon: me.image_icon,
                        image_icon_webp: me.image_icon_webp,
                        text_image_icon_alt: me.text_image_icon_alt,
                        approaches: me.approaches,
                    })
                    .then(function (response) {
                        me.image_path = response.data.image_path;
                        me.image_webp_path = response.data.image_webp_path;
                        me.image_icon_path = response.data.image_icon_path;
                        me.image_icon_webp_path =
                            response.data.image_icon_webp_path;
                        me.clearError();
                        me.showActionSuccess("Actualizacion exitosa!");
                    })
                    .catch(function (error) {
                        if (error.response && error.response.data) {
                            me.allerrors = error.response.data.errors;
                            me.showActionError("Existe campos vacios!");
                        }
                    });
            }
        },
        addRow: function () {
            this.approaches.push({
                description: "",
            });
        },
        removeElement: function (index) {
            this.approaches.splice(index, 1);
            this.allerrors.approaches = null;
        },
        validForm() {
            let me = this;
            let valid = true;

            if (!me.name) {
                me.allerrors.name = ["El campo nombre es obligatorio."];
                valid = false;
            } else if (me.name.length > 100) {
                me.allerrors.name = [
                    "El campo nombre debe tener máximo 100 caracteres",
                ];
                valid = false;
            } else {
                me.allerrors.name = null;
            }

            if (me.summary && me.summary.length > 156) {
                me.allerrors.summary = [
                    "El campo resumen debe tener máximo 150 caracteres",
                ];
                valid = false;
            } else {
                me.allerrors.summary = null;
            }

            if (me.text_image_alt && me.text_image_alt.length > 190) {
                me.allerrors.text_image_alt = [
                    "El campo image alt debe tener máximo 190 caracteres",
                ];
                valid = false;
            } else {
                me.allerrors.text_image_alt = null;
            }

            if (me.text_image_icon_alt && me.text_image_icon_alt.length > 190) {
                me.allerrors.text_image_icon_alt = [
                    "El campo image icon alt debe tener máximo 190 caracteres",
                ];
                valid = false;
            } else {
                me.allerrors.text_image_icon_alt = null;
            }

            if (!me.image) {
                me.allerrors.image = ["El campo imagen es obligatorio."];
                valid = false;
            }

            if (!me.image_icon) {
                me.allerrors.image_icon = [
                    "El campo imagen icon es obligatorio.",
                ];
                valid = false;
            }

            if (me.approaches.length === 0) {
                me.allerrors.approaches = ["Debe incluir al menos un enfoque"];
                valid = false;
            } else {
                me.allerrors.approaches = null;
            }
            return valid;
        },
        clearError() {
            let me = this;
            me.allerrors = {
                name: null,
                summary: null,
                image: null,
                image_webp: null,
                image_icon: null,
                image_icon_webp: null,
                text_image_alt: null,
                text_image_icon_alt: null,
                approaches: null,
            };
        },
        showActionSuccess(message) {
            const Toast = this.$swal.mixin({
                toast: true,
                icon: "success",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });

            Toast.fire({
                type: "success",
                title: message,
            });
        },
        showActionError(message) {
            const Toast = this.$swal.mixin({
                toast: true,
                icon: "error",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });

            Toast.fire({
                type: "error",
                title: message,
            });
        },
        getUploadImageUrl() {
            const appUrl = document.querySelector(
                'meta[name="app-url"]'
            ).content;
            return `${appUrl}api/upload-image`;
        },
        getDeleteFileUrl() {
            const appUrl = document.querySelector(
                'meta[name="app-url"]'
            ).content;
            return `${appUrl}api/delete-file`;
        },
    },
    mounted() {
        let me = this;
        const authUserId = document.querySelector('meta[name="x-user"]').content;
        if (me.model_id == 0) {
            me.action = `/api/categories?key=${authUserId}`;
            new qq.FineUploader({
                element: document.getElementById(
                    "fine-uploader-manual-trigger"
                ),
                request: {
                    endpoint: this.getUploadImageUrl(),
                },
                deleteFile: {
                    enabled: true, // defaults to false
                    endpoint: this.getDeleteFileUrl(),
                },
                template: "qq-template-manual-trigger",
                validation: {
                    allowedExtensions: ["jpeg", "jpg", "png", "svg"],
                    itemLimit: 1,
                    sizeLimit: 20971520,
                    image: {
                        maxHeight: 470,
                        minHeight: 470,
                        maxWidth: 704,
                        minWidth: 704,
                    },
                },
                messages: {
                    noFilesError: "Seleccione una imagen.",
                    maxWidthImageError:
                        "Dimensiones incorrectas debe ser de 704x470 px.",
                    minWidthImageError:
                        "Dimensiones incorrectas debe ser de 704x470 px.",
                    maxHeightImageError:
                        "Dimensiones incorrectas debe ser de 704x470 px.",
                    minHeightImageError:
                        "Dimensiones incorrectas debe ser de 704x470 px.",
                },
                callbacks: {
                    onComplete: function (id, name, response) {
                        if (response.success) {
                            me.allerrors["image"] = null;
                            me.image = response.path;
                        } else {
                            me.allerrors["image"] = ["Error en la imagen"];
                        }
                    },
                    onDeleteComplete: function (id, name, response) {
                        me.allerrors["image"] = null;
                        me.image = "";
                    },
                },
                multiple: false,
            });

            new qq.FineUploader({
                element: document.getElementById(
                    "fine-uploader-manual-trigger-webp"
                ),
                request: {
                    endpoint: this.getUploadImageUrl(),
                },
                deleteFile: {
                    enabled: true, // defaults to false
                    endpoint: this.getDeleteFileUrl(),
                },
                template: "qq-template-manual-trigger-webp",
                validation: {
                    allowedExtensions: ["webp"],
                    itemLimit: 1,
                    sizeLimit: 20971520,
                    image: {
                        maxHeight: 470,
                        minHeight: 470,
                        maxWidth: 704,
                        minWidth: 704,
                    },
                },
                messages: {
                    noFilesError: "Seleccione una imagen de tipo webp.",
                    maxWidthImageError:
                        "Dimensiones incorrectas debe ser de 704x470 px.",
                    minWidthImageError:
                        "Dimensiones incorrectas debe ser de 704x470 px.",
                    maxHeightImageError:
                        "Dimensiones incorrectas debe ser de 704x470 px.",
                    minHeightImageError:
                        "Dimensiones incorrectas debe ser de 704x470 px.",
                },
                callbacks: {
                    onComplete: function (id, name, response) {
                        if (response.success) {
                            me.allerrors["image_webp"] = null;
                            me.image_webp = response.path;
                        } else {
                            me.allerrors["image_webp"] = ["Error en la imagen"];
                        }
                    },
                    onDeleteComplete: function (id, name, response) {
                        me.allerrors["image_webp"] = "";
                        me.image_webp = "";
                    },
                },
                multiple: false,
            });
            new qq.FineUploader({
                element: document.getElementById(
                    "fine-uploader-manual-trigger-icon"
                ),
                request: {
                    endpoint: this.getUploadImageUrl(),
                },
                deleteFile: {
                    enabled: true, // defaults to false
                    endpoint: this.getDeleteFileUrl(),
                },
                template: "qq-template-manual-trigger-icon",
                validation: {
                    allowedExtensions: ["jpeg", "jpg", "png", "svg"],
                    itemLimit: 1,
                    sizeLimit: 20971520,
                },
                messages: {
                    noFilesError: "Seleccione una imagen.",
                },
                callbacks: {
                    onComplete: function (id, name, response) {
                        if (response.success) {
                            me.allerrors["image_icon"] = null;
                            me.image_icon = response.path;
                        } else {
                            me.allerrors["image_icon"] = ["Error en la imagen"];
                        }
                    },
                    onDeleteComplete: function (id, name, response) {
                        me.allerrors["image_icon"] = "";
                        me.image_icon = "";
                    },
                },
                multiple: false,
            });
            new qq.FineUploader({
                element: document.getElementById(
                    "fine-uploader-manual-trigger-icon-webp"
                ),
                request: {
                    endpoint: this.getUploadImageUrl(),
                },
                deleteFile: {
                    enabled: true, // defaults to false
                    endpoint: this.getDeleteFileUrl(),
                },
                template: "qq-template-manual-trigger-icon-webp",
                validation: {
                    allowedExtensions: ["webp"],
                    itemLimit: 1,
                    sizeLimit: 20971520,
                },
                messages: {
                    noFilesError: "Seleccione una imagen de tipo webp.",
                },
                callbacks: {
                    onComplete: function (id, name, response) {
                        if (response.success) {
                            me.allerrors["image_icon_webp"] = null;
                            me.image_icon_webp = response.path;
                        } else {
                            me.allerrors["image_icon_webp"] = [
                                "Error en la imagen",
                            ];
                        }
                    },
                    onDeleteComplete: function (id, name, response) {
                        me.allerrors["image_icon_webp"] = "";
                        me.image_icon_webp = "";
                    },
                },
                multiple: false,
            });
        } else {
            this.getModel();
            me.action = "/api/categories/update/" + me.model_id;
            new qq.FineUploader({
                element: document.getElementById(
                    "fine-uploader-manual-trigger"
                ),
                request: {
                    endpoint: this.getUploadImageUrl(),
                },
                template: "qq-template-manual-trigger",
                validation: {
                    allowedExtensions: ["jpeg", "jpg", "png", "svg"],
                    sizeLimit: 20971520,
                    image: {
                        maxHeight: 470,
                        minHeight: 470,
                        maxWidth: 704,
                        minWidth: 704,
                    },
                },
                messages: {
                    noFilesError: "Seleccione una imagen.",
                    maxWidthImageError:
                        "Dimensiones incorrectas debe ser de 704x470 px.",
                    minWidthImageError:
                        "Dimensiones incorrectas debe ser de 704x470 px.",
                    maxHeightImageError:
                        "Dimensiones incorrectas debe ser de 704x470 px.",
                    minHeightImageError:
                        "Dimensiones incorrectas debe ser de 704x470 px.",
                },
                callbacks: {
                    onComplete: function (id, name, response) {
                        if (response.success) {
                            me.allerrors["image"] = null;
                            me.image = response.path;
                        } else {
                            me.allerrors["image"] = ["Error en la imagen"];
                        }
                    },
                },
                multiple: false,
            });
            new qq.FineUploader({
                element: document.getElementById(
                    "fine-uploader-manual-trigger-webp"
                ),
                request: {
                    endpoint: this.getUploadImageUrl(),
                },
                template: "qq-template-manual-trigger-webp",
                validation: {
                    allowedExtensions: ["webp"],
                    sizeLimit: 20971520,
                    image: {
                        maxHeight: 470,
                        minHeight: 470,
                        maxWidth: 704,
                        minWidth: 704,
                    },
                },
                messages: {
                    noFilesError: "Seleccione una imagen de tipo webp.",
                    maxWidthImageError:
                        "Dimensiones incorrectas debe ser de 704x470 px.",
                    minWidthImageError:
                        "Dimensiones incorrectas debe ser de 704x470 px.",
                    maxHeightImageError:
                        "Dimensiones incorrectas debe ser de 704x470 px.",
                    minHeightImageError:
                        "Dimensiones incorrectas debe ser de 704x470 px.",
                },
                callbacks: {
                    onComplete: function (id, name, response) {
                        if (response.success) {
                            me.allerrors["image_webp"] = null;
                            me.image_webp = response.path;
                        } else {
                            me.allerrors["image_webp"] = ["Error en la imagen"];
                        }
                    },
                },
                multiple: false,
            });

            new qq.FineUploader({
                element: document.getElementById(
                    "fine-uploader-manual-trigger-icon"
                ),
                request: {
                    endpoint: this.getUploadImageUrl(),
                },
                template: "qq-template-manual-trigger-icon",
                validation: {
                    allowedExtensions: ["jpeg", "jpg", "png", "svg"],
                    sizeLimit: 20971520,
                },
                messages: {
                    noFilesError: "Seleccione una imagen.",
                },
                callbacks: {
                    onComplete: function (id, name, response) {
                        if (response.success) {
                            me.allerrors["image_icon"] = null;
                            me.image_icon = response.path;
                        } else {
                            me.allerrors["image_icon"] = ["Error en la imagen"];
                        }
                    },
                },
                multiple: false,
            });
            new qq.FineUploader({
                element: document.getElementById(
                    "fine-uploader-manual-trigger-icon-webp"
                ),
                request: {
                    endpoint: this.getUploadImageUrl(),
                },
                template: "qq-template-manual-trigger-icon-webp",
                validation: {
                    allowedExtensions: ["webp"],
                    sizeLimit: 20971520,
                },
                messages: {
                    noFilesError: "Seleccione una imagen de tipo webp.",
                },
                callbacks: {
                    onComplete: function (id, name, response) {
                        if (response.success) {
                            me.allerrors["image_icon_webp"] = null;
                            me.image_icon_webp = response.path;
                        } else {
                            me.allerrors["image_icon_webp"] = [
                                "Error en la imagen",
                            ];
                        }
                    },
                },
                multiple: false,
            });
        }
    },
};
</script>
<style>
.show-error {
    display: block;
    margin-top: 0.25rem;
    font-size: 0.875rem;
    color: #f86c6b;
}
</style>
